module.exports = __webpack_public_path__ + "static/media/in-icon.ffc1bf06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/icons/in-icon.svg
// module id = 59
// module chunks = 0